import { Separator } from '../../../../../primitives/separator';
import { Alignment } from '../controls/alignment';
import { Spacing } from '../controls/spacing';
import { Appearance } from './appearance';
import { Distribution } from './distribution';
import type { ColumnsEditorContentProps } from './types';

export type { ColumnsEditorStyleUpdates } from './types';

export function ColumnsEditorContent({
  backgroundColor,
  column1Width,
  column2Width,
  column3Width,
  columnsCount,
  columnsGap,
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  margin,
  verticalAlignment,
  onColumn1WidthChange,
  onColumn2WidthChange,
  onColumn3WidthChange,
  onColumnsCountChange,
  onColumnsGapChange,
  onStyleChange,
}: ColumnsEditorContentProps) {
  return (
    <div className="grid gap-4">
      <Distribution
        column1Width={column1Width}
        column2Width={column2Width}
        column3Width={column3Width}
        columnsCount={columnsCount}
        columnsGap={columnsGap}
        onColumn1WidthChange={onColumn1WidthChange}
        onColumn2WidthChange={onColumn2WidthChange}
        onColumn3WidthChange={onColumn3WidthChange}
        onColumnsCountChange={onColumnsCountChange}
        onColumnsGapChange={onColumnsGapChange}
      />

      <Separator />

      <Appearance
        backgroundColor={backgroundColor}
        onBackgroundColorChange={(backgroundColor) => onStyleChange({ backgroundColor })}
      />

      <Separator />

      <Alignment
        isVerticalAlignmentVisible
        verticalAlignment={verticalAlignment}
        onVerticalAlignmentChange={(newAlignment) =>
          onStyleChange({ verticalAlignment: newAlignment })
        }
      />

      <Separator />

      <Spacing
        margin={margin}
        onChangeMargin={(margin) => onStyleChange({ margin })}
        paddingTop={paddingTop}
        paddingBottom={paddingBottom}
        paddingLeft={paddingLeft}
        paddingRight={paddingRight}
        isPaddingVisible
        onChangePaddingBottom={(bottom) => onStyleChange({ padding: { bottom } })}
        onChangePaddingLeft={(left) => onStyleChange({ padding: { left } })}
        onChangePaddingRight={(right) => onStyleChange({ padding: { right } })}
        onChangePaddingTop={(top) => onStyleChange({ padding: { top } })}
      />
    </div>
  );
}
